import React from "react"
import PropTypes from "prop-types"
import {Table} from "antd"
const LovResultDetailAffiliation = ({links, loading}) => {
    const columns = [

        {title: 'APB Code', dataIndex: 'ApbCode', key:'ApbCode'},
        {title: 'Country', dataIndex: 'Country',key:'Country'},
        {title: 'Local Lov Type', dataIndex: 'localLovType', key:'localLovType'},
        {title: 'Value Label', dataIndex: 'ValLabelS', key: 'ValLabelS'}

    ];

    return (
        <Table
            columns={columns}
            dataSource={links}
            size="small"
            bordered
            loading={loading}
        />
    );
};

LovResultDetailAffiliation.propTypes = {
    loading: PropTypes.bool.isRequired
};


export default LovResultDetailAffiliation



// WEBPACK FOOTER //
// ./src/js/lovs/result/LovResultDetailAffiliation.js